import React from 'react';
import { Col, Row } from '@yme/atoms/grid';
import { Image as ImageAtom } from '@yme/atoms/image';
import { useSelector } from '@yme/hooks/useSelector';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { getRootLang } from '@yme/selectors/common';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { getFormattedDate } from '@yme/utils/common';
import { SubTitlePanel } from '../NewsPage/components/HeroSection/SubTitlePanel';
import { LogoStyled, HeroComponentStyled, ImageBgStyled, BottomContainer, ImageMaskStyled, CountryFlagStyled, HeaderTitle, } from './styled';
export function HeroSectionHeader(props) {
    const { isMobileView } = useWindowSize();
    const lang = useSelector(getRootLang);
    const { backgroundImage, title, subtitle, countryFlag, date, eventLogo } = props;
    const formattedDate = getFormattedDate({
        date,
        lang,
    });
    return (React.createElement(HeroComponentStyled, null,
        React.createElement(ImageBgStyled, null,
            React.createElement(ImageAtom, { ...backgroundImage }),
            React.createElement(ImageMaskStyled, null)),
        React.createElement(BottomContainer, null,
            React.createElement(Row, { justifyContent: "space-between", alignItems: "flex-end" },
                React.createElement(Col, { lg: 8, md: 5, sm: 3 },
                    React.createElement(FlexWrapper, { flexDirection: "column", justifyContent: "flex-end" },
                        React.createElement(SubTitlePanel, { subtitle: subtitle, date: formattedDate }),
                        !isMobileView && React.createElement(HeaderTitle, { color: colorCoreWhite1000 }, title))),
                React.createElement(Col, { lg: 2, md: 2, sm: 1 },
                    React.createElement(FlexWrapper, { flexDirection: "column", alignItems: "flex-end" },
                        eventLogo && React.createElement(LogoStyled, { ...eventLogo }),
                        countryFlag && React.createElement(CountryFlagStyled, { ...countryFlag })))))));
}
